var $thumbs = {
  // ======================================================================
  // VARS
  // ======================================================================

  current: null,
  currentHover: null,
  currentScroll: null,

  // ======================================================================
  // INIT
  // ======================================================================

  init: function() {
    // bind mouse events
    $('body').on('mouseenter', '.thumb', function() {
      if (!$events.touching) {
        var thumbId = parseInt($(this).attr('data-thumb'));
        $thumbs.hover(thumbId);
      }
    });
    $('body').on('mouseleave', '.thumb', function() {
      $thumbs.hover(null);
    });
    // set initial layout
    $thumbs.resetLayout(0);
  },

  // ======================================================================
  // THUMBS
  // ======================================================================

  hover: function(id) {
    if ($windowsize.isDesktop) {
      $thumbs.currentHover = id;
      $thumbs.update();
    }
  },
  scroll: function(id) {
    if ($windowsize.isDesktop && $device.isTouchScreen) {
      $thumbs.currentScroll = id;
      $thumbs.update();
    }
  },
  update: function(force) {
    // determine currently highighted thumb
    var newThumb;
    if ($thumbs.currentHover !== null) {
      // console.log('hover ' + $thumbs.currentHover);
      newThumb = $thumbs.currentHover;
    } else if ($thumbs.currentScroll !== null) {
      // console.log('scroll ' + $thumbs.currentScroll);
      newThumb = $thumbs.currentScroll;
    } else {
      // console.log('null');
      newThumb = null;
    }
    // apply highlight style
    if ($thumbs.current !== newThumb || force === true) {
      $thumbs.current = newThumb;
      var duration = 1;
      if (newThumb === null) {
        // reset everything
        $thumbs.resetLayout(duration);
      } else {
        // move prev thumbs left
        for (i = 1; i <= newThumb; i++) {
          gsap.to($el('[data-thumb=' + i + ']'), {
            xPercent: -14.4,
            duration: duration
          });
        }
        // move next thumbs right
        for (i = newThumb + 1; i <= $('.thumb').length; i++) {
          gsap.to($el('[data-thumb=' + i + ']'), {
            xPercent: 14.4,
            duration: duration
          });
        }
        // scale and move stuff
        for (i = 1; i <= $('.thumb').length; i++) {
          gsap.to($el('[data-thumb=' + i + '] .thumb__body'), {
            y: i === newThumb ? 0 : 30,
            opacity: i === newThumb ? 1 : 0,
            duration: duration
          });
          gsap.to($el('[data-thumb=' + i + '] .thumb__view-inner'), {
            yPercent: i === newThumb ? -270 : 0,
            duration: duration
          });
          gsap.to($el('[data-thumb=' + i + '] .thumb__img'), {
            scale: i === newThumb ? 1.333 : 1,
            duration: duration
          });
        }
      }
    }
  },
  reset: function() {
    $thumbs.currentHover = null;
    $thumbs.currentScroll = null;
    $thumbs.resetLayout(0);
  },
  resetLayout: function(duration) {
    var gsapFunc = duration === 0 ? gsap.set : gsap.to;
    gsapFunc($el('.thumb'), {
      xPercent: 0,
      duration: duration
    });
    gsapFunc($el('.thumb__body'), {
      y: 30,
      opacity: 0,
      duration: duration
    });
    gsapFunc($el('.thumb__view-inner'), {
      yPercent: 0,
      duration: duration
    });
    gsapFunc($el('.thumb__img'), {
      scale: 1,
      duration: duration
    });
  }
};
